module.exports = angular.module('cartographer.common.api.code', [])

_ = require 'underscore'

module.exports.factory 'crtCode', $DI (crtLog, crtConfig, crtPromise, crtHttp) ->
  plugins = {}

  # plugin -> void
  registerPlugin = (plugin) ->
    # crtLog.debug("Registering code plugin: #{plugin.id}")
    plugins[plugin.id] = plugin
    return

  # string -> plugin
  findPlugin = (type) ->
    plugins[type] ? throw new Error("crtCode.findPlugin: no such plugin: #{type}")

  # string -> arrayOf(value)
  values = (type) ->
    findPlugin(type).values

  value = (type, id) ->
    _.find(findPlugin(type)?.values ? [], (value) -> value.id == id)

  # string -> arrayOf(value)
  ids = (type) ->
    _.map(findPlugin(type).values, (value) -> value.id)

  return {
    plugins
    registerPlugin
    values
    value
    ids
  }

module.exports.filter 'code', $DI (crtLog, crtCode) ->
  (value, type, field = 'name') ->
    crtCode.value(type, value)?[field]
